export const selectStyles = {
  control: (base: any) => ({
    ...base,
    backgroundColor: '#f5f8fa',
    border: 'none',
    borderRadius: 6,
    minHeight: 42,
    fontSize: 13,
    boxShadow: 'none',
  }),
  placeholder: (base: any) => ({ ...base, color: '#a1a5b7' }),
  singleValue: (base: any) => ({ ...base, color: '#3f4254' }),
}
